import React from "react";
import AppHeader from "../../../components/Header";
import LandingFooter from "../../../components/landingFooter";
import Banner from "./Banner";
import BestFor from "./BestFor";
import ChooseUs from "./ChooseUs";
import Faqs from "./Faq";
import FeesSections from "./FeesSection";
import GrowBussiness from "./GrowBussiness";
import NextBussiness from "./NextBusiness";
import Testimonials from "./Testimonials";
import VariantManage from "./Variant";

function Home() {
  return (
    <AppHeader>
      <Banner />
      <BestFor />
      <VariantManage />
      <ChooseUs />
      <GrowBussiness />
      <FeesSections />
      <Testimonials />
      <Faqs />
      <NextBussiness />
    </AppHeader>
  );
}

export default Home;
